"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _PriceChange = _interopRequireDefault(require("../components/PriceChange"));
var _Loading = _interopRequireDefault(require("../components/Loading"));
var _order = require("@/api/order");
var _validate = require("@/utils/validate");
var _dialog = require("@/libs/dialog");
var _utils = require("@/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t4 in e) "default" !== _t4 && {}.hasOwnProperty.call(e, _t4) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t4)) && (i.get || i.set) ? o(f, _t4, i) : f[_t4] = e[_t4]); return f; })(e, t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "AdminOrderList",
  components: {
    PriceChange: _PriceChange.default,
    Loading: _Loading.default
  },
  props: {},
  data: function data() {
    return {
      isWriteOff: (0, _utils.isWriteOff)(),
      current: "",
      change: false,
      types: 0,
      where: {
        page: 1,
        limit: 10,
        status: 'unPaid'
      },
      list: [],
      loaded: false,
      loading: false,
      orderInfo: {},
      status: null
    };
  },
  watch: {
    "$route.params.types": function $routeParamsTypes(newVal) {
      var that = this;
      if (newVal != undefined) {
        that.where.status = newVal;
        that.init();
      }
    },
    types: function types() {
      this.getIndex();
    }
  },
  created: function created() {
    Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/assets/js/media_750'));
    });
  },
  mounted: function mounted() {
    var _this = this;
    this.where.status = this.$route.params.types;
    this.current = "";
    this.getIndex();
    this.$scroll(this.$refs.container, function () {
      !_this.loading && _this.getIndex();
    });
  },
  methods: {
    more: function more(index) {
      if (this.current === index) this.current = "";else this.current = index;
    },
    modify: function modify(item, status) {
      this.change = true;
      this.orderInfo = item;
      this.status = status;
    },
    changeclose: function changeclose(msg) {
      this.change = msg;
      this.init();
    },
    // 拒绝退款
    getRefuse: function getRefuse(id, reason) {
      var _this2 = this;
      (0, _order.orderRefuseApi)({
        orderNo: id,
        reason: reason
      }).then(function () {
        _this2.change = false;
        _this2.$dialog.success("已拒绝退款");
        _this2.init();
      }).catch(function (error) {
        _this2.$dialog.error(error.message);
      });
    },
    savePrice: function () {
      var _savePrice = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(opt) {
        var that, data, price, refundPrice, refundStatus, remark, _t, _t2, _t3;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              that = this, data = {}, price = opt.price, refundPrice = opt.refundPrice, refundStatus = that.orderInfo.refundStatus, remark = opt.remark;
              if (!(that.status == 0 && refundStatus === 0)) {
                _context.n = 5;
                break;
              }
              _context.p = 1;
              _context.n = 2;
              return this.$validator({
                price: [(0, _validate.required)(_validate.required.message("金额"))]
              }).validate({
                price: price
              });
            case 2:
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              return _context.a(2, (0, _dialog.validatorDefaultCatch)(_t));
            case 4:
              data.price = price;
              data.orderNo = opt.orderId;
              (0, _order.editPriceApi)(data).then(function () {
                that.change = false;
                that.$dialog.success("改价成功");
                that.init();
              }).catch(function (error) {
                that.$dialog.error(error.message);
              });
              _context.n = 14;
              break;
            case 5:
              if (!(that.status == 0 && refundStatus === 1)) {
                _context.n = 10;
                break;
              }
              _context.p = 6;
              _context.n = 7;
              return this.$validator({
                refundPrice: [(0, _validate.required)(_validate.required.message("金额")), (0, _validate.num)(_validate.num.message("金额"))]
              }).validate({
                refundPrice: refundPrice
              });
            case 7:
              _context.n = 9;
              break;
            case 8:
              _context.p = 8;
              _t2 = _context.v;
              return _context.a(2, (0, _dialog.validatorDefaultCatch)(_t2));
            case 9:
              data.amount = refundPrice;
              data.type = opt.type;
              data.orderNo = opt.orderId;
              (0, _order.orderRefundApi)(data).then(function (res) {
                that.change = false;
                that.$dialog.success('退款成功');
                that.init();
              }, function (err) {
                that.change = false;
                that.$dialog.error(err.message);
              });
              _context.n = 14;
              break;
            case 10:
              _context.p = 10;
              _context.n = 11;
              return this.$validator({
                remark: [(0, _validate.required)(_validate.required.message("备注"))]
              }).validate({
                remark: remark
              });
            case 11:
              _context.n = 13;
              break;
            case 12:
              _context.p = 12;
              _t3 = _context.v;
              return _context.a(2, (0, _dialog.validatorDefaultCatch)(_t3));
            case 13:
              data.mark = remark;
              data.orderNo = opt.orderId;
              (0, _order.orderMarkApi)(data).then(function (res) {
                that.change = false;
                that.$dialog.success('提交成功');
                that.init();
              }, function (err) {
                that.change = false;
                that.$dialog.error(err.message);
              });
            case 14:
              return _context.a(2);
          }
        }, _callee, this, [[10, 12], [6, 8], [1, 3]]);
      }));
      function savePrice(_x) {
        return _savePrice.apply(this, arguments);
      }
      return savePrice;
    }(),
    init: function init() {
      this.list = [];
      this.where.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getIndex();
      this.current = "";
    },
    getIndex: function getIndex() {
      var _this3 = this;
      if (this.loading || this.loaded) return;
      this.loading = true;
      (0, _order.orderListApi)(this.where).then(function (res) {
        _this3.loading = false;
        _this3.loaded = res.list.length < _this3.where.limit;
        _this3.list.push.apply(_this3.list, res.list);
        _this3.where.page = _this3.where.page + 1;
      }, function (err) {
        _this3.$dialog.error(err.message);
      });
    },
    changeStatus: function changeStatus(val) {
      if (this.where.status != val) {
        this.where.status = val;
        this.init();
      }
    },
    toDetail: function toDetail(item) {
      this.$router.push({
        path: "/javaMobile/orderDetail/" + item.orderId
      });
    },
    offlinePay: function offlinePay(item) {
      // setOfflinePay({ order_id: item.order_id }).then(
      //   res => {
      //     this.$dialog.success(res.message);
      //     this.init();
      //   },
      //   error => {
      //     this.$dialog.error(error.message);
      //   }
      // );
    }
  }
};